import * as Types from 'src/actions/juridical-person/get/Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { AxiosResponse } from 'axios';
import { RootState } from 'src/reducers/RootReducer';
import JuridicalPerson from 'src/entities/JuridicalPerson';
import ValidatorService from 'src/services/validation/Validation.service';

export interface GetJuridicalPersonAttempt extends Action {
  type: Types.GET_JURIDICAL_PERSON_ATTEMPT;
}

export interface GetJuridicalPersonSuccess extends Action {
  type: Types.GET_JURIDICAL_PERSON_SUCCESS;
  payload: JuridicalPerson;
}

export interface GetJuridicalPersonFailure extends Action {
  type: Types.GET_JURIDICAL_PERSON_FAILURE;
  payload: {};
}

export type GetJuridicalPersonAction =
  GetJuridicalPersonAttempt
  | GetJuridicalPersonSuccess
  | GetJuridicalPersonFailure;

export interface GetJuridicalPersonThunk extends ThunkAction<Promise<GetJuridicalPersonAction>, RootState, string> {
}

export const getJuridicalPersonAttempt: ActionCreator<GetJuridicalPersonAttempt> = () => (
  {
    type: Types.GET_JURIDICAL_PERSON_ATTEMPT
  }
);

export const getJuridicalPersonSuccess: ActionCreator<GetJuridicalPersonSuccess> = (
  juridicalPerson: JuridicalPerson) => (
    {
      type: Types.GET_JURIDICAL_PERSON_SUCCESS,
      payload: juridicalPerson
    }
  );

export const getJuridicalPersonFailure: ActionCreator<GetJuridicalPersonFailure> = (error: {}) => (
  {
    type: Types.GET_JURIDICAL_PERSON_FAILURE,
    payload: error
  }
);

export const getJuridicalPerson: ActionCreator<GetJuridicalPersonThunk> =
  (id: string): GetJuridicalPersonThunk => {
    return (dispatch: Dispatch<RootState>): Promise<GetJuridicalPersonAction> => {
      dispatch(getJuridicalPersonAttempt());

      return ApiClient.juridicalPerson.get(id)
        .then((response: AxiosResponse<JuridicalPerson>): GetJuridicalPersonSuccess => {
          return dispatch(getJuridicalPersonSuccess(response.data));
        }).catch((e: { response: { data: { error: {} } } }): GetJuridicalPersonFailure => {
          const errorMessages = ValidatorService
            .translateValidations(e && e.response && e.response.data && e.response.data.error);

          return dispatch(getJuridicalPersonFailure(errorMessages));
        });
    };
  };



// WEBPACK FOOTER //
// ./src/actions/juridical-person/get/GetJuridicalPerson.actions.ts